import { InjectionToken } from '@angular/core';

export interface IMusicService {
    playSound(path: string, volume?: number): any;
}

export const MUSIC_SERVICE_TOKEN = new InjectionToken<IMusicService>('IMusicService');
